<script>
	import { validator } from "../validation";
	import RelativeDiagnosisModel from "../models/RelativeDiagnosis";

	import RelativeDiagnosis from "./RelativeDiagnosis.svelte";
	import FormRow from "./FormRow.svelte";
	import FormColumn from "./FormColumn.svelte";
	import AddButton from "./buttons/AddButton.svelte";

	export let diagnoses = [];
	export let disabled = null;
	export let diagnosisType = null;
	export let relativeIndex = null;

	const deleteDiagnosis = (index) => {
		if (diagnoses.length <= 1) return;
		diagnoses.splice(index, 1);
		diagnoses = [...diagnoses];
	};

	const addDiagnosis = () => {
		var errors = isValid();
		if (errors.length !== 0) {
			return;
		}

		diagnoses = [...diagnoses, new RelativeDiagnosisModel(diagnosisType)];
	};

	export const isValid = () => {
		return $validator.validateAll(document.querySelector(`#diagnoses-${diagnosisType}${relativeIndex}`));
	};
</script>

<div id="diagnoses-{diagnosisType}{relativeIndex}">
	<FormRow>
		<FormColumn cols="6" class="d-none d-md-block">
			<!-- svelte-ignore a11y-label-has-associated-control -->
			<label>{diagnosisType === "CANCER" ? "Type of cancer" : "Type of mutation"}</label>
		</FormColumn>
		<FormColumn cols="6" class="d-none d-md-block">
			<!-- svelte-ignore a11y-label-has-associated-control -->
			<label>Diagnosed</label>
		</FormColumn>
	</FormRow>

	{#each diagnoses as diagnosis, i (diagnosis)}
		<RelativeDiagnosis
			bind:diagnosis
			numberOfDiagnoses={diagnoses.length}
			index={i}
			{disabled}
			{diagnosisType}
			on:delete-diagnosis={() => deleteDiagnosis(i)}
		/>
	{/each}

	<div class="confirmation-hide" style="margin-top: 26px;">
		<AddButton on:add={addDiagnosis}>Add Diagnosis</AddButton>
	</div>
</div>
